import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RejectCandidateConfirmationPopup } from '~/components/PermanentJobsV2/JobOverview';
import { DeclineCandidateConfirmationPopup } from '~/components/PermanentJobsV2/JobOverview/components';
import { EnablePermanentJobM2M } from '~/constants/ff.posthog';
import { useLoading } from '~/hooks';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import {
  fireConfirmCandidateConfirmClicked,
  fireConfirmCandidateDeclineClicked,
  fireConfirmCandidateDeclineConfirmed,
} from '~/posthogs/events';
import { confirmJob, DECLINE_CANDIDATE, declineCandidate } from '../../../actions';
import Button from '../../../commonComponents/Button';
import { isPartialShift } from '../../../commonComponents/CommonFunctions';
import { Colors } from '../../../themes/colors';
import CounterShiftPopup from '../../CounterShiftPopup';
import DeclineCandidatePopup from '../../DeclineCandidatePopup';

export const ConfirmOrDecline = ({ candidateId, notesForTemp, allowNavigation, onDeclineConfirmed, small = false }) => {
  const dispatch = useDispatch();

  const [declineCandidatePopup, setDeclineCandidatePopup] = useState(false);
  const [counterShiftPopup, setCounterShiftPopup] = useState(false);
  const { job, allCandidates } = useSelector((state) => state.job);
  const currentCounter = allCandidates?.find((counter) => counter?.candidate?.id === candidateId);
  const isCounterHours = isPartialShift(currentCounter);

  const { isLoading: isDeclineCandidateLoading } = useLoading([DECLINE_CANDIDATE]);

  const isOnsiteInterview = job?.isOnsiteInterview;

  const isEnablePermanentJobM2M = useFeatureFlag(EnablePermanentJobM2M);

  const declineCandidatePressed = () => {
    fireConfirmCandidateDeclineClicked({ shiftId: job.id });
    setDeclineCandidatePopup(true);
  };

  const handleAcceptClicked = () => {
    setCounterShiftPopup(false);
    confirmOffer();
  };

  const handleCancelClicked = () => {
    setCounterShiftPopup(false);
  };

  const handleConfirmDecline = (reason = '') => {
    fireConfirmCandidateDeclineConfirmed({ shiftId: job.id });
    onDeclineConfirmed?.(allCandidates?.length > 1);
    dispatch(
      declineCandidate({
        jobId: job.id,
        counterOfferId: currentCounter?.id,
        cancellation_reason: reason,
        candidateId: currentCounter?.candidate?.id,
      }),
    );
    setDeclineCandidatePopup(false);
  };

  const confirmOffer = () => {
    fireConfirmCandidateConfirmClicked({ shiftId: job.id });
    allowNavigation();

    dispatch(
      confirmJob({
        jobId: job.id,
        data: { notes: notesForTemp },
        counterOfferId: currentCounter?.id,
        candidate: currentCounter?.candidate,
        officeId: job?.offer_owner?.id,
      }),
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      <Button
        text="Decline"
        style={{
          width: !small ? 152 : 120,
          height: !small ? 48 : 34,
          backgroundColor: Colors.secondary_500,
          marginRight: !small ? 20 : 12,
          marginTop: 0,
        }}
        onClick={declineCandidatePressed}
      />
      <Button
        text="Confirm"
        style={{
          width: !small ? 152 : 120,
          height: !small ? 48 : 34,
          marginTop: 0,
          backgroundColor: Colors.primary_500,
        }}
        onClick={() => {
          if (isCounterHours) {
            setCounterShiftPopup(true);
          } else {
            confirmOffer();
          }
        }}
      />

      {declineCandidatePopup && (
        <>
          {isOnsiteInterview ? (
            <>
              {isEnablePermanentJobM2M ? (
                <DeclineCandidateConfirmationPopup
                  isLoading={isDeclineCandidateLoading}
                  jobLocalDate={job.local_date}
                  professionalName={`${currentCounter?.candidate?.first_name} ${currentCounter?.candidate?.last_name}`}
                  onClose={() => setDeclineCandidatePopup(false)}
                  onConfirm={() => handleConfirmDecline('')}
                />
              ) : (
                <RejectCandidateConfirmationPopup
                  isLoading={isDeclineCandidateLoading}
                  professionalName={`${currentCounter?.candidate?.first_name} ${currentCounter?.candidate?.last_name}`}
                  useDeclineTerms
                  onClose={() => setDeclineCandidatePopup(false)}
                  onConfirm={() => handleConfirmDecline('')}
                />
              )}
            </>
          ) : (
            <DeclineCandidatePopup
              declineBtnPressed={handleConfirmDecline}
              goBackPressed={() => setDeclineCandidatePopup(false)}
            />
          )}
        </>
      )}

      {counterShiftPopup ? (
        <CounterShiftPopup
          job={job}
          currentCounter={currentCounter}
          acceptBtnPressed={handleAcceptClicked}
          cancelBtnPressed={handleCancelClicked}
        />
      ) : null}
    </div>
  );
};
